// extracted by mini-css-extract-plugin
export var dividerLine = "_40-0";
export var errorBackground = "_40-1";